import { Box, Typography } from "@mui/material";

/**
 * Consistent page wrapper for admin sections: title, optional subtitle, and content.
 * Use same padding and max-width for all list/detail pages.
 */
const PageLayout = ({ title, subtitle, action, children, maxWidth = "1400px" }) => {
  return (
    <Box
      sx={{
        width: "100%",
        maxWidth,
        mx: "auto",
        px: { xs: 2, sm: 3 },
        py: 3,
        minHeight: "calc(100vh - 64px)",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "space-between",
          alignItems: "flex-start",
          gap: 2,
          mb: 3,
        }}
      >
        <Box>
          <Typography variant="h4" sx={{ fontWeight: 700, color: "primary.main", letterSpacing: "-0.02em" }}>
            {title}
          </Typography>
          {subtitle && (
            <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
              {subtitle}
            </Typography>
          )}
        </Box>
        {action && <Box sx={{ flexShrink: 0 }}>{action}</Box>}
      </Box>
      {children}
    </Box>
  );
};

export default PageLayout;
